<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
    <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel()">{{data.cancelText || 'Cancel'}}</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">{{data.confirmText || 'Confirm'}}</button>
</mat-dialog-actions>
